import type { QueryClient } from '@tanstack/react-query';
export const financeAccessEvent = 'ministryiq-finance-access-changed';
export async function clearFinancialState(client: QueryClient, churchId: string) {
  await client.cancelQueries({ queryKey: ['giving', churchId] });
  client.removeQueries({ queryKey: ['giving', churchId], predicate: q => q.queryKey[2] !== 'access' });
  client.setQueryData(['giving', churchId, 'access'], { enabled: false, currency: null, permissions: [] });
  await client.invalidateQueries({ queryKey: ['giving', churchId, 'access'] });
}
export function announceFinanceAccessChange(churchId: string) {
  window.dispatchEvent(new window.CustomEvent(financeAccessEvent, { detail: churchId }));
  if (typeof BroadcastChannel !== 'undefined') {
    const channel = new BroadcastChannel(financeAccessEvent);
    channel.postMessage(churchId);
    channel.close();
  }
}
